import React, { useState } from "react";
import {
    Breadcrumb,
    Checkbox,
    FormControl,
    FormGroup,
    Row,
    Col,
    Panel,
} from "react-bootstrap";
import PanelBody from "react-bootstrap/lib/PanelBody";
import PanelHeading from "react-bootstrap/lib/PanelHeading";
import PanelTitle from "react-bootstrap/lib/PanelTitle";
import { LinkContainer } from "react-router-bootstrap";
import { messageLengthMax, messageLengthMin } from "./lib";
import { SORT_METHOD_TYPE } from "../models";
import locale from "../../../../locale";
import { useEventContext, useModuleSettingsContext, useUserContext } from "../../../../context";
import Activity from "./Activity";
import Reactions from "./Reactions";

const EnablingModules = () => {
    const {
        moduleBranding,
        moduleEpisode,
        moduleComment,
        moduleQuestion,
        moduleMain,
        moduleQuiz,
        moduleShop,
        onSaveBranding,
        onSaveEpisode,
        onSaveComment,
        onSaveQuestion,
        onSaveMain,
        onSaveQuiz,
        onSaveShop,
        setPropertyComment,
        setPropertyQuestion,
        isSaving,
    } = useModuleSettingsContext();
    const { event } = useEventContext();
    const { userIsAdmin } = useUserContext();
    const [educationEnabled, setEducationEnabled] = useState(moduleMain.clientCertificateEnabled || moduleMain.presence || false);
    const [votingEnabled, setVotingEnabled] = useState(moduleQuestion.sortMethodType || false);

    const setMaxMessage = (value, module = 'comment') => {
        if (value < messageLengthMin || value > messageLengthMax) {
            return;
        }

        if (module === 'comment') {
            setPropertyComment('maxMessageLength', value);
        } else {
            setPropertyQuestion('maxMessageLength', value);
        }
    };

    const changeEducationEnabled = (value) => {
        setEducationEnabled(value);

        if (!value) {
            onSaveMain({ clientCertificateEnabled: false, presence: false });
        }
    };

    const handleEnableVoting = (value) => {
        setVotingEnabled(value);
        onSaveQuestion({ sortMethodType: value ? SORT_METHOD_TYPE.RATING : SORT_METHOD_TYPE.NONE });
    };

    return (
        <section>
            <Breadcrumb>
                <LinkContainer to={`/event/${event.eventPassword}`}>
                    <Breadcrumb.Item>{locale('mainMenu.eventSettings')}</Breadcrumb.Item>
                </LinkContainer>
                <Breadcrumb.Item active>{locale('mainMenu.eventSettings.enablingModules')}</Breadcrumb.Item>
            </Breadcrumb>

            <div style={{ display: 'flex', gap: '2rem' }}>
                <Panel style={{ flex: 1 }}>
                    <PanelHeading>
                        <PanelTitle>Программа</PanelTitle>
                    </PanelHeading>
                    <PanelBody>
                        <Row>
                            <Col xs={6}>
                                <FormGroup>
                                    <Checkbox
                                        checked={moduleEpisode.enabled}
                                        onChange={(e) => onSaveEpisode({ enabled: e.target.checked })}
                                    >Включить Программу</Checkbox>
                                </FormGroup>
                                {moduleEpisode.enabled && (
                                    <>
                                        <Checkbox
                                            checked={moduleEpisode.episodeFavorite}
                                            onChange={(e) => onSaveEpisode({ episodeFavorite: e.target.checked })}
                                        >Включить избранное</Checkbox>
                                        {moduleEpisode.episodeFavorite &&
                                            <Checkbox
                                                checked={moduleEpisode.notificationsAllowed}
                                                onChange={(e) => onSaveEpisode({ notificationsAllowed: e.target.checked })}
                                            >Включить рассылку об избранном</Checkbox>
                                        }
                                        <Checkbox
                                            checked={moduleEpisode.like}
                                            onChange={(e) => onSaveEpisode({ like: e.target.checked })}
                                        >Лайк эпизодов</Checkbox>
                                    </>
                                )}
                            </Col>
                        </Row>
                    </PanelBody>
                </Panel>
                <Panel style={{ flex: 1 }}>
                    <PanelHeading>
                        <PanelTitle>Спикеры</PanelTitle>
                    </PanelHeading>
                    <PanelBody>
                        <Row>
                            <Col xs={6}>
                                <FormGroup>
                                    <Checkbox
                                        checked={moduleEpisode.membersEnabled}
                                        onChange={(e) => onSaveEpisode({ membersEnabled: e.target.checked })}
                                    >Включить Спикеров</Checkbox>
                                </FormGroup>
                            </Col>
                        </Row>
                    </PanelBody>
                </Panel>
            </div>
            <div style={{ display: 'flex', gap: '2rem' }}>
                <Panel style={{ flex: 1 }}>
                    <PanelHeading>
                        <PanelTitle>Чат</PanelTitle>
                    </PanelHeading>
                    <PanelBody>
                        <Row>
                            <Col xs={6}>
                                <FormGroup>
                                    <Checkbox
                                        checked={moduleComment.enabled}
                                        onChange={(e) => onSaveComment({ enabled: e.target.checked })}
                                    >Включить Чат</Checkbox>
                                </FormGroup>
                                {moduleComment.enabled && (
                                    <>
                                        <FormGroup>
                                            <Checkbox
                                                checked={moduleComment.likesEnabled}
                                                onChange={(e) => onSaveComment({ likesEnabled: e.target.checked })}
                                            >Лайк комментариев</Checkbox>
                                        </FormGroup>
                                        <FormGroup>
                                            <Checkbox
                                                checked={moduleComment.dislikesEnabled}
                                                onChange={(e) => onSaveComment({ dislikesEnabled: e.target.checked })}
                                            >Дизлайк комментариев</Checkbox>
                                        </FormGroup>
                                    </>
                                )}
                            </Col>
                            {moduleComment.enabled && (
                                <Col xs={6}>
                                    <FormGroup>
                                        <Checkbox
                                            checked={moduleComment.moderate}
                                            onChange={(e) => onSaveComment({ moderate: e.target.checked })}
                                        >Премодерация</Checkbox>
                                    </FormGroup>
                                    <FormGroup>
                                        <Checkbox
                                            checked={moduleComment.allowAnonymousMessage}
                                            onChange={(e) => onSaveComment({ allowAnonymousMessage: e.target.checked })}
                                        >Разрешить анонимные сообщения</Checkbox>
                                    </FormGroup>
                                </Col>
                            )}
                        </Row>
                        {moduleComment.enabled && (
                            <Row>
                                <Col xs={6}>
                                    <FormGroup>
                                        <p>Максимальная длина сообщения (символов)</p>
                                        <FormControl
                                            type="number"
                                            max={messageLengthMax}
                                            min={messageLengthMin}
                                            value={moduleComment.maxMessageLength}
                                            onChange={(e) => setMaxMessage(e.target.value || messageLengthMin, 'comment')}
                                            onBlur={() => onSaveComment({ maxMessageLength: moduleComment.maxMessageLength })}
                                            disabled={isSaving}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        )}
                    </PanelBody>
                </Panel>
                <Panel style={{ flex: 1 }}>
                    <PanelHeading>
                        <PanelTitle>Вопросы</PanelTitle>
                    </PanelHeading>
                    <PanelBody>
                        <Row>
                            <Col xs={6}>
                                <FormGroup>
                                    <Checkbox
                                        checked={moduleQuestion.enabled}
                                        onChange={(e) => onSaveQuestion({ enabled: e.target.checked })}
                                    >Включить Вопросы</Checkbox>
                                </FormGroup>
                                {moduleQuestion.enabled && (
                                    <>
                                        <FormGroup>
                                            <Checkbox
                                                checked={moduleQuestion.likesEnabled}
                                                onChange={(e) => onSaveQuestion({ likesEnabled: e.target.checked })}
                                            >Лайк вопросов</Checkbox>
                                        </FormGroup>
                                        <FormGroup>
                                            <Checkbox
                                                checked={moduleQuestion.dislikesEnabled}
                                                onChange={(e) => onSaveQuestion({ dislikesEnabled: e.target.checked })}
                                            >Дизлайк вопросов</Checkbox>
                                        </FormGroup>
                                        <FormGroup>
                                            <Checkbox
                                                checked={moduleQuestion.moderate}
                                                onChange={(e) => onSaveQuestion({ moderate: e.target.checked })}
                                            >Премодерация</Checkbox>
                                        </FormGroup>
                                        <FormGroup>
                                            <Checkbox
                                                checked={moduleQuestion.themesEnabled}
                                                onChange={(e) => onSaveQuestion({ themesEnabled: e.target.checked })}
                                            >Темы вопросов</Checkbox>
                                        </FormGroup>
                                    </>
                                )}
                            </Col>
                            {moduleQuestion.enabled && (
                                <Col xs={6}>
                                    <FormGroup>
                                        <Checkbox
                                            checked={moduleQuestion.allowEpisodeMessage}
                                            onChange={(e) => onSaveQuestion({ allowEpisodeMessage: e.target.checked })}
                                        >Привязывать вопросы к эпизоду</Checkbox>
                                    </FormGroup>
                                    <FormGroup>
                                        <Checkbox
                                            checked={moduleQuestion.allowTargetMessage}
                                            onChange={(e) => onSaveQuestion({ allowTargetMessage: e.target.checked })}
                                        >Адресный вопрос участнику</Checkbox>
                                    </FormGroup>
                                    <FormGroup>
                                        <Checkbox
                                            checked={moduleQuestion.allowAnonymousMessage}
                                            onChange={(e) => onSaveQuestion({ allowAnonymousMessage: e.target.checked })}
                                        >Разрешить анонимные вопросы</Checkbox>
                                    </FormGroup>
                                    <FormGroup>
                                        <Checkbox
                                            checked={moduleQuestion.allowTargetBeforeStart}
                                            onChange={(e) => onSaveQuestion({ allowTargetBeforeStart: e.target.checked })}
                                        >Вопросы на лендинге до начала трансляции</Checkbox>
                                    </FormGroup>
                                    <FormGroup>
                                        <Checkbox
                                            checked={votingEnabled}
                                            onChange={(e) => handleEnableVoting(e.target.checked)}
                                        >Голосование</Checkbox>
                                    </FormGroup>
                                </Col>
                            )}
                        </Row>
                        {moduleQuestion.enabled && (
                            <Row>
                                <Col xs={6}>
                                    <FormGroup>
                                        <p>Максимальная длина сообщения (символов)</p>
                                        <FormControl
                                            type="number"
                                            max={messageLengthMax}
                                            min={messageLengthMin}
                                            value={moduleQuestion.maxMessageLength}
                                            onChange={(e) => setMaxMessage(e.target.value || messageLengthMin, 'question')}
                                            onBlur={() => onSaveQuestion({ maxMessageLength: moduleQuestion.maxMessageLength })}
                                            disabled={isSaving}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        )}
                    </PanelBody>
                </Panel>
            </div>

            <Reactions />

            <div style={{ display: 'flex', gap: '2rem', alignItems: 'flex-start' }}>
                <Activity />
                <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                    <Panel style={{ flex: 1 }}>
                        <PanelHeading>
                            <PanelTitle>Дополнительно</PanelTitle>
                        </PanelHeading>
                        <PanelBody>
                            <FormGroup>
                                <Row>
                                    <Col xs={6}>
                                        <Checkbox
                                            checked={moduleQuiz.enabled}
                                            onChange={(e) => onSaveQuiz({ enabled: e.target.checked })}
                                        >Включить Квизы</Checkbox>
                                        <Checkbox
                                            checked={moduleBranding.offlinePageEnabled}
                                            onChange={(e) => onSaveBranding({ offlinePageEnabled: e.target.checked })}
                                        >Включить модуль Офлайн участники</Checkbox>
                                        <Checkbox
                                            checked={moduleBranding.allowSMSNotifications}
                                            onChange={(e) => onSaveBranding({ allowSMSNotifications: e.target.checked })}
                                        >Включить СМС уведомления</Checkbox>
                                        {userIsAdmin &&
                                            <Checkbox
                                                checked={moduleShop.enabled}
                                                onChange={(e) => onSaveShop({ enabled: e.target.checked })}
                                            >Магазин призов</Checkbox>
                                        }
                                    </Col>
                                    <Col xs={6}>

                                        <Checkbox
                                            checked={educationEnabled}
                                            onChange={(e) => changeEducationEnabled(e.target.checked)}
                                        >Включить модуль Обучение</Checkbox>
                                        {educationEnabled && (
                                            <>
                                                <Checkbox
                                                    checked={moduleMain.clientCertificateEnabled}
                                                    onChange={(e) => onSaveMain({ clientCertificateEnabled: e.target.checked })}
                                                >Сертификат зрителя</Checkbox>
                                                <Checkbox
                                                    checked={moduleMain.presence}
                                                    onChange={(e) => onSaveMain({ presence: e.target.checked })}
                                                >Контроль присутствия</Checkbox>
                                            </>
                                        )}
                                    </Col>
                                </Row>
                            </FormGroup>
                        </PanelBody>
                    </Panel>
                </div>
            </div>
        </section>
    );
};

export default EnablingModules;
